import {
  createRolesApi,
  deleteRoleApi,
  getAllPermissionsApi,
  getAllRolesApi,
  getRoleByIdApi,
  updateRoleApi,
} from "../../helpers/backend_helper";
import {
  getRolesList,
  errorMessages,
  roleByIdData,
  permissionListData,
  loadingData,
} from "./reducer";

export const getAllRoleList = (currentPage, pageSize, searchText) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "read", value: true }));
    let response;
    response = getAllRolesApi(currentPage, pageSize, searchText);
    const data = await response;

    dispatch(getRolesList(data));
  } catch (error) {
    dispatch(errorMessages("Some thing went wrong, please try later"));
  } finally {
    dispatch(loadingData({ type: "read", value: false }));
  }
};

export const getRoleById = (id) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "getById", value: true }));
    let response;
    response = getRoleByIdApi(id);
    const data = await response;
    dispatch(roleByIdData(data));
  } catch (error) {
    const errorMessage = error.response.data.errors;
    dispatch(errorMessages(errorMessage));
  } finally {
    dispatch(loadingData({ type: "getById", value: false }));
  }
};

export const createRole = (data) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "create", value: true }));
    const response = await createRolesApi(data);
    return { success: true, message: "Role Successfully Created" };
  } catch (error) {
    const errorMessage = error.response.data.errors;
    dispatch(errorMessages(errorMessage));
    return {
      success: false,
      message: errorMessage || "Failed to create role",
    };
  } finally {
    dispatch(loadingData({ type: "create", value: false }));
  }
};

export const updateRole = (id, data) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "update", value: true }));
    let response;
    response = await updateRoleApi(id, data);
    return { success: true, message: "Role Successfully Updated" };
  } catch (error) {
    const errorMessage = error.response.data.errors;
    dispatch(errorMessages(errorMessage));
    return {
      success: false,
      message: errorMessage || "Failed to update role",
    };
  } finally {
    dispatch(loadingData({ type: "update", value: false }));
  }
};

export const deleteRole = (id) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "delete", value: true }));
    const response = await deleteRoleApi(id);
    return { success: true, message: "Role Successfully Deleted" };
  } catch (error) {
    const errorMessage = error.response.data.errors;
    dispatch(errorMessages(errorMessage));
    return { success: false, message: errorMessage || "Failed to delete role" };
  } finally {
    dispatch(loadingData({ type: "delete", value: false }));
  }
};

export const getAllPermissionList = () => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "getPermissionList", value: true }));
    let response;
    response = getAllPermissionsApi();
    const data = await response;

    dispatch(permissionListData(data));
  } catch (error) {
    dispatch(errorMessages("Some thing went wrong, please try later"));
  } finally {
    dispatch(loadingData({ type: "getPermissionList", value: false }));
  }
};
